export default {
	title: 'share',
	icon: 'far fa-share-nodes',
	components: [{ title: 'share', component: 'share' }],
};
